// extracted by mini-css-extract-plugin
export default {"section_content":"privacypolicy_section_content__t2mtC","pere_content_box":"privacypolicy_pere_content_box__RWTKM"};